import { IconWrapper, ISvgIconProps } from "@icon-park/svg/lib/runtime";

export default IconWrapper(
  "chart-line-down",
  (props: ISvgIconProps) =>
    `<svg width="${props.size}" height="${props.size}" viewBox="0 0 48 48" fill="none">` +
    `<path d="M6 6V42H42" stroke="${props.colors[0]}" stroke-width="${props.strokeWidth}" stroke-linecap="${props.strokeLinecap}" stroke-linejoin="${props.strokeLinejoin}"/>` +
    `<path d="M42 34L34 18L24 27L14 6V34H42Z" stroke="${props.colors[0]}" stroke-width="${props.strokeWidth}" stroke-linejoin="${props.strokeLinejoin}"/>` +
    "</svg>",
);
